export type Direction = "across" | "down";

export default interface Selection {
    direction: "across" | "down";
    clue: number;
}

export function toggleDirection(dir: Direction): Direction {
    return dir === "across" ? "down" : "across";
}